import React from "react";
import { createTrackingUtils } from "..";
import useUserAgent from "../../../hooks/useUserAgent";
import useRouteName from "../../../hooks/useRouteName";
import { useCheckInData } from "../../../hooks/useCheckInData";
import { UIOrder } from "@flights/types";

export const trackCheckinPage = createTrackingUtils({
  defaultStage: 1,
  name: "flights_web_pb_checkin_page_v2_m2",
  stages: {
    AFFECTED_USERS: 1,
    CHECKIN_PAGE: 2,
    CHECKIN_PAGE_DDOT: 3,
    CHECKIN_PAGE_MDOT: 4,
    CHECKIN_PAGE_LESS_THAN_24H: 5,
    CHECKIN_PAGE_MORE_THAN_24H: 6
  },
  goals: {
    CLICK_WHENCHECKIN: 1,
    CLICK_HOWCHECKIN: 2
  },
  goalsWithValue: []
});

export const useTrackCheckinPage = (order: UIOrder) => {
  const { isMobile } = useUserAgent();
  const routeName = useRouteName();
  const isCheckinPage = routeName === "pb-web-checkin";
  const { hasAtLeastOneCheckInOpened } = useCheckInData(order);

  const isVariant = isCheckinPage && trackCheckinPage.trackWithDefaultStage() === 1;

  React.useEffect(() => {
    if (isCheckinPage) {
      trackCheckinPage.stages.CHECKIN_PAGE();

      if (isMobile) {
        trackCheckinPage.stages.CHECKIN_PAGE_MDOT();
      } else {
        trackCheckinPage.stages.CHECKIN_PAGE_DDOT();
      }

      if (hasAtLeastOneCheckInOpened) {
        trackCheckinPage.stages.CHECKIN_PAGE_LESS_THAN_24H();
      } else {
        trackCheckinPage.stages.CHECKIN_PAGE_MORE_THAN_24H();
      }
    }
  }, [isMobile, isCheckinPage, hasAtLeastOneCheckInOpened]);

  return {
    isCheckinPageExperimentVariant: isVariant
  };
};
